import { ENV } from "../constants/env";

export const getUserEnv = () => {
  const host = window.location.host;

  if (host.startsWith("localhost")) return ENV.LOCAL;
  if (host.startsWith("dev-")) return ENV.DEV;
  return ENV.PROD;
};
